import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes'

import { RESULT_PAYMENT } from 'shared/api/check-payment'

import { ToursError } from './components/tours-error'
import { ToursPending } from './components/tours-pending'
import { ToursSuccess } from './components/tours-success'

type Props = {
  status: RESULT_PAYMENT
}

export const ToursPayment = ({ status }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const onClick = () => {
    navigate(RoutingPaths.tours.path())
  }

  const onSuccessClick = () => {
    navigate(RoutingPaths.myOrders.path())
  }

  if (status === RESULT_PAYMENT.CANCELLED) {
    return <ToursError onClick={onClick} />
  }

  if (
    status === RESULT_PAYMENT.IN_PROGRESS ||
    status === RESULT_PAYMENT.CREATED ||
    status === RESULT_PAYMENT.LOADING
  ) {
    return <ToursPending onClick={onClick} />
  }
  return (
    <ToursSuccess
      title={t('payment_success.tours_title')}
      description={t('payment_success.tours_description')}
      buttonText={t('my_orders')}
      onClick={onSuccessClick}
    />
  )
}
